import * as React from 'react'
import { observer } from 'mobx-react'
import Icon from 'components/Icon'
import Button from 'components/Button'
import { Dropdown, DropdownDivider, DropdownTitle } from 'components/Dropdown'
import { RadioGroup, RadioItem } from 'components/RadioGroup'
import { JobPeriodFilterOption } from 'jobs/views/JobManagement/JobPeriodFilterOption'
import JobSearchViewModel, {
  JobScopeFilterOption,
} from 'jobs/infra/JobSearchViewModel'

interface JobFilterViewHeadingProps {
  vm: JobSearchViewModel
}

export default observer(function JobFilterViewHeading({
  vm,
}: JobFilterViewHeadingProps) {
  return (
    <Dropdown
      autoDismiss
      width="small"
      button={
        <Button iconRight={<Icon name="dropdown" size={14} />}>
          Filter View
        </Button>
      }
    >
      {vm.showSearchScopeFilter && (
        <>
          <DropdownTitle>View</DropdownTitle>
          <RadioGroup>
            <RadioItem
              selected={vm.scope === JobScopeFilterOption.All}
              onChange={() => vm.setScope(JobScopeFilterOption.All)}
            >
              All jobs
            </RadioItem>
            <RadioItem
              selected={vm.scope === JobScopeFilterOption.Mine}
              onChange={() => vm.setScope(JobScopeFilterOption.Mine)}
            >
              My jobs
            </RadioItem>
          </RadioGroup>
          <DropdownDivider />
        </>
      )}
      <DropdownTitle>Filter by period</DropdownTitle>
      <RadioGroup>
        <RadioItem
          selected={vm.jobPeriodOption === JobPeriodFilterOption.All}
          onChange={() => vm.setJobPeriod(JobPeriodFilterOption.All)}
        >
          All jobs
        </RadioItem>
        <RadioItem
          selected={vm.jobPeriodOption === JobPeriodFilterOption.Current}
          onChange={() => vm.setJobPeriod(JobPeriodFilterOption.Current)}
        >
          Current jobs
        </RadioItem>
        <RadioItem
          selected={vm.jobPeriodOption === JobPeriodFilterOption.Old}
          onChange={() => vm.setJobPeriod(JobPeriodFilterOption.Old)}
        >
          Old jobs
        </RadioItem>
      </RadioGroup>
    </Dropdown>
  )
})
